import { FIELD_TYPES } from 'src/api/process-module';
import { FieldComponentConfig } from './FieldNameLabelInputs';

export const getConfigForType = (type: string): FieldComponentConfig => {
  switch (type) {
    case FIELD_TYPES.DIVIDER:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: true,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: false,
          enabled: false,
          accessLevel: false,
          placeholder: false,
        },
      };
    case FIELD_TYPES.MARKDOWN:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: true,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: true,
          enabled: false,
          accessLevel: true,
          placeholder: false,
        },
      };
    case FIELD_TYPES.IMAGE:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: true,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: false,
          enabled: false,
          accessLevel: false,
          placeholder: false,
        },
      };
    case FIELD_TYPES.DROPDOWN:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: false,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: true,
          enabled: false,
          accessLevel: true,
          placeholder: false,
        },
      };
    case FIELD_TYPES.HTML:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: true,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: true,
          enabled: false,
          accessLevel: true,
          placeholder: false,
        },
      };
    case FIELD_TYPES.INNOVATION_READINESS_LEVELS:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: true,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: true,
          accessLevel: false,
          placeholder: false,
          enabled: true,
        },
      };
    case FIELD_TYPES.PROCESS_MODULE_INFINITE_CANVAS:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: false,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: 'Label for the canvas field',
        showProperties: {
          visible: true,
          enabled: false,
          accessLevel: true,
          placeholder: false,
        },
      };
    case FIELD_TYPES.CHECKBOX_LIST:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: false,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: true,
          enabled: false,
          accessLevel: true,
          placeholder: false,
        },
      };
    case FIELD_TYPES.COMMENT:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: false,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: true,
          enabled: false,
          accessLevel: true,
          placeholder: false,
        },
      };
    case FIELD_TYPES.FILE_UPLOAD:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: true,
        hideLabel: false,
        hideRequired: true,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: true,
          enabled: false,
          accessLevel: true,
          placeholder: false,
        },
      };

    default:
      return {
        nameLabel: 'Field Name',
        labelLabel: 'Field Label',
        hideName: false,
        hideLabel: false,
        hideRequired: false,
        nameHelperText: '',
        labelHelperText: '',
        showProperties: {
          visible: true,
          enabled: true,
          accessLevel: true,
          placeholder: true,
        },
      };
  }
};
